/////////////////////////////////////////////////////////////
import { Link } from 'react-router-dom';
import { ArrowRight } from '@/app/shared/components';

interface MenuOptionProps {
	title: string;
	path: string;
	selected: string;
}

export const MenuOption: React.FC<MenuOptionProps> = ({
	title,
	path,
	selected,
}: MenuOptionProps) => {
	/*********************
	// #region Template
	**********************/
	return (
		<Link to={path}>
			<div className="flex rounded-2xl items-center bg-customer-900/50 p-3 option-menu-setting">
				<div className="flex flex-col w-full ml-3 gap-1">
					<p className="text-md0 font-bold">{title}</p>
					<p className="text-sm font-semibold">{selected}</p>
				</div>
				<div className="p-3">
					<ArrowRight fillcolor="white" />
				</div>
			</div>
		</Link>
	);
};
